/**
 * Renders the static boot-error panel defined in `index.html` when the
 * Angular app fails to bootstrap (e.g. `RuntimeConfigService.load()`
 * throws, or any other `APP_INITIALIZER` rejects).
 *
 * Must not import anything Angular: by the time this runs, bootstrap
 * has already failed, so there is no injector, no zone, no router.
 * Pure DOM manipulation only.
 */
export function renderBootError(err: unknown): void {
  const panel = document.getElementById('boot-error');
  const detail = document.getElementById('boot-error-detail');
  const appRoot = document.querySelector('app-root');

  if (panel) {
    panel.removeAttribute('hidden');
  }
  if (detail) {
    detail.textContent = err instanceof Error ? (err.stack ?? err.message) : String(err);
  }
  if (appRoot instanceof HTMLElement) {
    appRoot.style.display = 'none';
  }
}
